import { useEffect } from "react";

/**
 * Lightweight SEO hook: sets <title>, meta description, and og:title/og:description
 * for each page on mount. Restores the previous title on unmount.
 */
export function useSeo({ title, description }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [key, keyValue] = selector.replace(/[[\]"']/g, "").split("=");
        el.setAttribute(key === "meta" ? "name" : key, keyValue || "");
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', "content", title);
      setMeta('meta[name="twitter:title"]', "content", title);
    }

    return () => { document.title = prevTitle; };
  }, [title, description]);
}
